// 报告后台展示头部
<template>
  <div class="header df-between" :style='{"max-width":isWeb==1?"1200px":"","min-width":isWeb==1?"1000px":"","margin":isWeb==1?"0 auto":""}'>
    <div class="left df-center">报告详情</div>
    <div class="right df-center">
      <div class='btn df-center'  @click="setWord">下载</div>
      <div class='btn df-center'  @click="handleCatelogue">目录</div>
    </div>
  </div>
</template>

<script>
    export default {
      props:['isWeb'],
      data(){
        return{
        }
      },
      methods:{
        setWord() {
          this.$emit('setWord')
        },
        handleCatelogue() {
          this.$emit('handleCatelogue')
        }
      },
      computed:{
      },
      mounted(){
      },
      watch:{
      }
    }
</script>

<style lang="scss" scoped>
  .header{
    width: 100%;
    padding: 10px 15px 10px;
    // position: fixed;
    // top: 0;
    // left: 0;
    z-index: 1000;
    font-size: 16px;
    background-color: #E5E5E5;
    .left{
      color: #333;
    }
    .right{
      .btn{
        height: 35px;
        width: 80px;
        margin-right: 20px;
        background-color: #56CBFB;
        color: #fff;
        font-size: 16px;
      }

    }
  }
</style>
